module.exports={
	"birthDate": "",
	"fullName": {
		"first": "",
		"last": ""
	},
	"gender": "",
	"relationshipCode": "",
	"memberCoverages": [],
	"medicareEligible": {},
	"mnloa": {},
	"medicareEligibleIndicator": "unknown",
	"otherInsuranceIndicator": "unknown"
}
